import { Typography } from '@mui/material';
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator, timelineItemClasses } from '@mui/lab';
import { SUBMISSION_STATUS_COLOR, SubmissionStatus } from '../../../../model/ser/ser-enums';
import { ISubmissionHistoryResponse } from '../../../../model/ser/submission/response/submission-detail-response';
import { formatDateTime } from '../../../../utils/date';

// Linha do tempo das mudanças de status, em ordem cronológica
export function HistoryTimeline({ history }: { history: ISubmissionHistoryResponse[] }) {
    if (history.length === 0) return <Typography variant="body2" color="text.secondary">Sem histórico registrado</Typography>;

    return (
        <Timeline sx={{ p: 0, m: 0, [`& .${timelineItemClasses.root}:before`]: { flex: 0, padding: 0 } }}>
            {history.map((item, index) => (
                <TimelineItem key={item.id}>
                    <TimelineSeparator>
                        <TimelineDot sx={{ bgcolor: SUBMISSION_STATUS_COLOR[item.statusId as SubmissionStatus]?.hex ?? 'grey.500', boxShadow: 'none' }} />
                        {index < history.length - 1 && <TimelineConnector />}
                    </TimelineSeparator>
                    <TimelineContent sx={{ pb: 2 }}>
                        <Typography variant="body2" fontWeight={700}>
                            {item.previousStatus ? `${item.previousStatus} → ${item.status}` : item.status}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" component="div">
                            {formatDateTime(item.date)}{item.user?.name ? ` · ${item.user.name}` : ''}
                        </Typography>
                        {item.observation && <Typography variant="body2" sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}>{item.observation}</Typography>}
                    </TimelineContent>
                </TimelineItem>
            ))}
        </Timeline>
    );
}
